import { Outlet } from "react-router-dom";
import SideMenu from "../menu/SideMenu";

const DashBoardLayout = () => {
  return (
    <div style={{
        gridTemplateColumns: "auto 1fr"
      }} className="min-h-dvh grid">
      <aside className="h-dvh sticky top-0 left-0">
        <SideMenu />
      </aside>
      <div className="px-5 lg:pl-12 lg:pr-20 py-10 min-h-dvh flex flex-col relative overflow-x-auto" style={{ backgroundColor: '#F9FAFB' }}>
        <main className="grow flex flex-col">
          <Outlet />
        </main>        
      </div>
    </div>
  )
}

export default DashBoardLayout;